<div class="flex justify-center items-center">
<div class="flex flex-col justify-center items-center sm:max-w-[376px]">
    <ln-ln-cone-svg-icon></ln-ln-cone-svg-icon>
    <p class="text-cafe text-center text-base font-normal font-['Roboto'] leading-normal pt-[14px]">
      {{'messages.noResultsMatchYourSearchCriteria'| transloco}}
    </p>
  </div>
</div>
